import type { ReactNode } from "react";
import { cx } from "../../components/ui.js";

/**
 * Um recado dentro de um painel: informação (brasa), impedimento ou perigo (descartar).
 *
 * É o mesmo desenho do `Nota` da impressão, escrito aqui de propósito: aquele mora noutra feature, e
 * uma tela não deve passar a depender de um arquivo que não é dela.
 */
export function Aviso({
  tom,
  children,
  className,
}: {
  tom: "informacao" | "perigo";
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cx(
        "rounded-peca border px-3 py-2.5 text-[0.875rem] leading-relaxed text-texto",
        tom === "perigo"
          ? "border-descartar/40 bg-descartar/10"
          : "border-brasa/30 bg-brasa-fraca/40",
        className,
      )}
    >
      {children}
    </div>
  );
}
